import { UPDATE_DRAWER_ERROR, UPDATE_DRAWER_START, UPDATE_DRAWER_SUCCESS } from "../../types";

export default function update_drawer(state, action) {
    switch (action.type) {
        case UPDATE_DRAWER_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_DRAWER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case UPDATE_DRAWER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
